import '@backstage/cli/asset-types'
import ReactDOM from 'react-dom/client'
import App from './App'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto-condensed/700.css'
import '@backstage/ui/css/styles.css'
import './theme/deepgaming.css'

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot())
